import * as yup from 'yup';

export const blastingAgreementSchema = yup.object().shape({
	agreed: yup.string().required('Agreeing to conditions is required.'),
	title: yup.string().required('Title is required.'),
	email: yup.string().email().required('Email is required.'),
	name: yup.string().required('Name is required.'),
});
